"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.useHideButtonText = (showOnOverlay, hidden) => {
    return react_1.useMemo(() => {
        return hidden ? 'Show' : showOnOverlay ? 'Hide' : '';
        // hidden ? (hidden ? 'Show' : 'Hide') : '';
    }, [showOnOverlay, hidden]);
};
//# sourceMappingURL=useHideButtonText.js.map